import { CountryCode as CodigoInternacionalTelefone } from "app/components/selecionarCodigoTelefoneInternacional/SelecionarCodigoTelefoneInternacional";

export const listaCodigoInternacionalTelefone: CodigoInternacionalTelefone[] = [
    { code: 'BR', country: 'Brasil', dialCode: '+55' },
    { code: 'AF', country: 'Afeganistão', dialCode: '+93' },
    { code: 'AL', country: 'Albânia', dialCode: '+355' },
    { code: 'DZ', country: 'Argélia', dialCode: '+213' },
    { code: 'AD', country: 'Andorra', dialCode: '+376' },
    { code: 'AO', country: 'Angola', dialCode: '+244' },
    { code: 'AG', country: 'Antígua e Barbuda', dialCode: '+1-268' },
    { code: 'AR', country: 'Argentina', dialCode: '+54' },
    { code: 'AM', country: 'Armênia', dialCode: '+374' },
    { code: 'AU', country: 'Austrália', dialCode: '+61' },
    { code: 'AT', country: 'Áustria', dialCode: '+43' },
    { code: 'AZ', country: 'Azerbaijão', dialCode: '+994' },
    { code: 'BS', country: 'Bahamas', dialCode: '+1-242' },
    { code: 'BH', country: 'Bahrein', dialCode: '+973' },
    { code: 'BD', country: 'Bangladesh', dialCode: '+880' },
    { code: 'BB', country: 'Barbados', dialCode: '+1-246' },
    { code: 'BY', country: 'Bielorrússia', dialCode: '+375' },
    { code: 'BE', country: 'Bélgica', dialCode: '+32' },
    { code: 'BZ', country: 'Belize', dialCode: '+501' },
    { code: 'BJ', country: 'Benin', dialCode: '+229' },
    { code: 'BT', country: 'Butão', dialCode: '+975' },
    { code: 'BO', country: 'Bolívia', dialCode: '+591' },
    { code: 'BA', country: 'Bósnia e Herzegovina', dialCode: '+387' },
    { code: 'BW', country: 'Botswana', dialCode: '+267' },
    { code: 'BN', country: 'Brunei', dialCode: '+673' },
    { code: 'BG', country: 'Bulgária', dialCode: '+359' },
    { code: 'BF', country: 'Burkina Faso', dialCode: '+226' },
    { code: 'BI', country: 'Burundi', dialCode: '+257' },
    { code: 'KH', country: 'Camboja', dialCode: '+855' },
    { code: 'CM', country: 'Camarões', dialCode: '+237' },
    { code: 'CA', country: 'Canadá', dialCode: '+1' },
    { code: 'CV', country: 'Cabo Verde', dialCode: '+238' },
    { code: 'CF', country: 'República Centro-Africana', dialCode: '+236' },
    { code: 'TD', country: 'Chade', dialCode: '+235' },
    { code: 'CL', country: 'Chile', dialCode: '+56' },
    { code: 'CN', country: 'China', dialCode: '+86' },
    { code: 'CO', country: 'Colômbia', dialCode: '+57' },
    { code: 'KM', country: 'Comores', dialCode: '+269' },
    { code: 'CG', country: 'Congo', dialCode: '+242' },
    { code: 'CR', country: 'Costa Rica', dialCode: '+506' },
    { code: 'HR', country: 'Croácia', dialCode: '+385' },
    { code: 'CU', country: 'Cuba', dialCode: '+53' },
    { code: 'CY', country: 'Chipre', dialCode: '+357' },
    { code: 'CZ', country: 'República Tcheca', dialCode: '+420' },
    { code: 'DK', country: 'Dinamarca', dialCode: '+45' },
    { code: 'DJ', country: 'Djibouti', dialCode: '+253' },
    { code: 'DM', country: 'Dominica', dialCode: '+1-767' },
    { code: 'DO', country: 'República Dominicana', dialCode: '+1-809' },
    { code: 'US', country: 'Estados Unidos', dialCode: '+1' },
    { code: 'EC', country: 'Equador', dialCode: '+593' },
    { code: 'EG', country: 'Egito', dialCode: '+20' },
    { code: 'SV', country: 'El Salvador', dialCode: '+503' },
    { code: 'GQ', country: 'Guiné Equatorial', dialCode: '+240' },
    { code: 'ER', country: 'Eritreia', dialCode: '+291' },
    { code: 'EE', country: 'Estônia', dialCode: '+372' },
    { code: 'ET', country: 'Etiópia', dialCode: '+251' },
    { code: 'FJ', country: 'Fiji', dialCode: '+679' },
    { code: 'FI', country: 'Finlândia', dialCode: '+358' },
    { code: 'FR', country: 'França', dialCode: '+33' },
    { code: 'GA', country: 'Gabão', dialCode: '+241' },
    { code: 'GM', country: 'Gâmbia', dialCode: '+220' },
    { code: 'GE', country: 'Geórgia', dialCode: '+995' },
    { code: 'DE', country: 'Alemanha', dialCode: '+49' },
    { code: 'GH', country: 'Gana', dialCode: '+233' },
    { code: 'GR', country: 'Grécia', dialCode: '+30' },
    { code: 'GD', country: 'Granada', dialCode: '+1-473' },
    { code: 'GT', country: 'Guatemala', dialCode: '+502' },
    { code: 'GN', country: 'Guiné', dialCode: '+224' },
    { code: 'GW', country: 'Guiné-Bissau', dialCode: '+245' },
    { code: 'GY', country: 'Guiana', dialCode: '+592' },
    { code: 'HT', country: 'Haiti', dialCode: '+509' },
    { code: 'HN', country: 'Honduras', dialCode: '+504' },
    { code: 'HU', country: 'Hungria', dialCode: '+36' },
    { code: 'IS', country: 'Islândia', dialCode: '+354' },
    { code: 'IN', country: 'Índia', dialCode: '+91' },
    { code: 'ID', country: 'Indonésia', dialCode: '+62' },
    { code: 'IR', country: 'Irã', dialCode: '+98' },
    { code: 'IQ', country: 'Iraque', dialCode: '+964' },
    { code: 'IE', country: 'Irlanda', dialCode: '+353' },
    { code: 'IL', country: 'Israel', dialCode: '+972' },
    { code: 'IT', country: 'Itália', dialCode: '+39' },
    { code: 'JM', country: 'Jamaica', dialCode: '+1-876' },
    { code: 'JP', country: 'Japão', dialCode: '+81' },
    { code: 'JO', country: 'Jordânia', dialCode: '+962' },
    { code: 'KZ', country: 'Cazaquistão', dialCode: '+7' },
    { code: 'KE', country: 'Quênia', dialCode: '+254' },
    { code: 'KI', country: 'Kiribati', dialCode: '+686' },
    { code: 'KP', country: 'Coreia do Norte', dialCode: '+850' },
    { code: 'KR', country: 'Coreia do Sul', dialCode: '+82' },
    { code: 'KW', country: 'Kuwait', dialCode: '+965' },
    { code: 'KG', country: 'Quirguistão', dialCode: '+996' },
    { code: 'LA', country: 'Laos', dialCode: '+856' },
    { code: 'LV', country: 'Letônia', dialCode: '+371' },
    { code: 'LB', country: 'Líbano', dialCode: '+961' },
    { code: 'LS', country: 'Lesoto', dialCode: '+266' },
    { code: 'LR', country: 'Libéria', dialCode: '+231' },
    { code: 'LY', country: 'Líbia', dialCode: '+218' },
    { code: 'LI', country: 'Liechtenstein', dialCode: '+423' },
    { code: 'LT', country: 'Lituânia', dialCode: '+370' },
    { code: 'LU', country: 'Luxemburgo', dialCode: '+352' },
    { code: 'MG', country: 'Madagáscar', dialCode: '+261' },
    { code: 'MW', country: 'Malawi', dialCode: '+265' },
    { code: 'MY', country: 'Malásia', dialCode: '+60' },
    { code: 'MV', country: 'Maldivas', dialCode: '+960' },
    { code: 'ML', country: 'Mali', dialCode: '+223' },
    { code: 'MT', country: 'Malta', dialCode: '+356' },
    { code: 'MH', country: 'Ilhas Marshall', dialCode: '+692' },
    { code: 'MR', country: 'Mauritânia', dialCode: '+222' },
    { code: 'MU', country: 'Maurício', dialCode: '+230' },
    { code: 'MX', country: 'México', dialCode: '+52' },
    { code: 'FM', country: 'Micronésia', dialCode: '+691' },
    { code: 'MD', country: 'Moldávia', dialCode: '+373' },
    { code: 'MC', country: 'Mônaco', dialCode: '+377' },
    { code: 'MN', country: 'Mongólia', dialCode: '+976' },
    { code: 'ME', country: 'Montenegro', dialCode: '+382' },
    { code: 'MA', country: 'Marrocos', dialCode: '+212' },
    { code: 'MZ', country: 'Moçambique', dialCode: '+258' },
    { code: 'MM', country: 'Mianmar', dialCode: '+95' },
    { code: 'NA', country: 'Namíbia', dialCode: '+264' },
    { code: 'NR', country: 'Nauru', dialCode: '+674' },
    { code: 'NP', country: 'Nepal', dialCode: '+977' },
    { code: 'NL', country: 'Países Baixos', dialCode: '+31' },
    { code: 'NZ', country: 'Nova Zelândia', dialCode: '+64' },
    { code: 'NI', country: 'Nicarágua', dialCode: '+505' },
    { code: 'NE', country: 'Níger', dialCode: '+227' },
    { code: 'NG', country: 'Nigéria', dialCode: '+234' },
    { code: 'NO', country: 'Noruega', dialCode: '+47' },
    { code: 'OM', country: 'Omã', dialCode: '+968' },
    { code: 'PK', country: 'Paquistão', dialCode: '+92' },
    { code: 'PW', country: 'Palau', dialCode: '+680' },
    { code: 'PS', country: 'Palestina', dialCode: '+970' },
    { code: 'PA', country: 'Panamá', dialCode: '+507' },
    { code: 'PG', country: 'Papua Nova Guiné', dialCode: '+675' },
    { code: 'PY', country: 'Paraguai', dialCode: '+595' },
    { code: 'PE', country: 'Peru', dialCode: '+51' },
    { code: 'PH', country: 'Filipinas', dialCode: '+63' },
    { code: 'PL', country: 'Polônia', dialCode: '+48' },
    { code: 'PT', country: 'Portugal', dialCode: '+351' },
    { code: 'QA', country: 'Catar', dialCode: '+974' },
    { code: 'GB', country: 'Reino Unido', dialCode: '+44' },
    { code: 'RO', country: 'Romênia', dialCode: '+40' },
    { code: 'RU', country: 'Rússia', dialCode: '+7' },
    { code: 'RW', country: 'Ruanda', dialCode: '+250' },
    { code: 'KN', country: 'São Cristóvão e Neves', dialCode: '+1-869' },
    { code: 'LC', country: 'Santa Lúcia', dialCode: '+1-758' },
    { code: 'VC', country: 'São Vicente e Granadinas', dialCode: '+1-784' },
    { code: 'WS', country: 'Samoa', dialCode: '+685' },
    { code: 'SM', country: 'San Marino', dialCode: '+378' },
    { code: 'ST', country: 'São Tomé e Príncipe', dialCode: '+239' },
    { code: 'SA', country: 'Arábia Saudita', dialCode: '+966' },
    { code: 'SN', country: 'Senegal', dialCode: '+221' },
    { code: 'RS', country: 'Sérvia', dialCode: '+381' },
    { code: 'SC', country: 'Seychelles', dialCode: '+248' },
    { code: 'SL', country: 'Serra Leoa', dialCode: '+232' },
    { code: 'SG', country: 'Singapura', dialCode: '+65' },
    { code: 'SK', country: 'Eslováquia', dialCode: '+421' },
    { code: 'SI', country: 'Eslovênia', dialCode: '+386' },
    { code: 'SB', country: 'Ilhas Salomão', dialCode: '+677' },
    { code: 'SO', country: 'Somália', dialCode: '+252' },
    { code: 'ZA', country: 'África do Sul', dialCode: '+27' },
    { code: 'SS', country: 'Sudão do Sul', dialCode: '+211' },
    { code: 'ES', country: 'Espanha', dialCode: '+34' },
    { code: 'LK', country: 'Sri Lanka', dialCode: '+94' },
    { code: 'SD', country: 'Sudão', dialCode: '+249' },
    { code: 'SR', country: 'Suriname', dialCode: '+597' },
    { code: 'SZ', country: 'Eswatini', dialCode: '+268' },
    { code: 'SE', country: 'Suécia', dialCode: '+46' },
    { code: 'CH', country: 'Suíça', dialCode: '+41' },
    { code: 'SY', country: 'Síria', dialCode: '+963' },
    { code: 'TW', country: 'Taiwan', dialCode: '+886' },
    { code: 'TJ', country: 'Tajiquistão', dialCode: '+992' },
    { code: 'TZ', country: 'Tanzânia', dialCode: '+255' },
    { code: 'TH', country: 'Tailândia', dialCode: '+66' },
    { code: 'TL', country: 'Timor-Leste', dialCode: '+670' },
    { code: 'TG', country: 'Togo', dialCode: '+228' },
    { code: 'TO', country: 'Tonga', dialCode: '+676' },
    { code: 'TT', country: 'Trinidad e Tobago', dialCode: '+1-868' },
    { code: 'TN', country: 'Tunísia', dialCode: '+216' },
    { code: 'TR', country: 'Turquia', dialCode: '+90' },
    { code: 'TM', country: 'Turcomenistão', dialCode: '+993' },
    { code: 'TV', country: 'Tuvalu', dialCode: '+688' },
    { code: 'UG', country: 'Uganda', dialCode: '+256' },
    { code: 'UA', country: 'Ucrânia', dialCode: '+380' },
    { code: 'AE', country: 'Emirados Árabes Unidos', dialCode: '+971' },
    { code: 'UY', country: 'Uruguai', dialCode: '+598' },
    { code: 'UZ', country: 'Uzbequistão', dialCode: '+998' },
    { code: 'VU', country: 'Vanuatu', dialCode: '+678' },
    { code: 'VA', country: 'Vaticano', dialCode: '+379' },
    { code: 'VE', country: 'Venezuela', dialCode: '+58' },
    { code: 'VN', country: 'Vietnã', dialCode: '+84' },
    { code: 'YE', country: 'Iêmen', dialCode: '+967' },
    { code: 'ZM', country: 'Zâmbia', dialCode: '+260' },
    { code: 'ZW', country: 'Zimbábue', dialCode: '+263' },
  ];
  